// import axios from 'axios-promise'
import qs from 'qs'
import { COTType } from './COTType'
import axios from 'axios'

export class CotalkerApi {
    baseURL: string | null;
    constructor(baseURL: string | null) {
        this.baseURL = baseURL;
    }

    async findBot(data: any, headers: any): Promise<COTType[]> {
        return (await axios({url: `${this.baseURL}/api/bots/find`, method: 'POST',  data, headers})).data;
    }

    async findChannels(data: any, headers: any): Promise<COTType[]> {
        return (await axios({url: `${this.baseURL}/api/channels/find`, method: 'POST',  data, headers})).data;
    }

    async findGroups(data: any, headers: any): Promise<COTType[]> {
        return (await axios({url: `${this.baseURL}/api/groups/find`, method: 'POST',  data, headers})).data;
    }

    async getPropertyByCode(propertyCode: string, headers: any): Promise<COTType> {
        return (await axios({ url: `${this.baseURL}/api/properties/findByCode/${propertyCode}`, method: 'GET', headers })).data;
    }

    async getProperty(id: string, headers: any): Promise<COTType> {
        return (await axios({url: `${this.baseURL}/api/properties/${String(id)}`, method: 'GET',  headers})).data;
    }

    async getSMStateForTaskGroup(taskGroup: string, headers: any): Promise<COTType[]> {
        return (await axios({ url: `${this.baseURL}/api/tasks/${String(taskGroup)}/sm/smstate`, method: 'GET', headers })).data;
    }

    async getSurveyById(surveyId: string, headers: any): Promise<COTType[]> {
        return (await axios({ url: `${this.baseURL}/api/surveys/${surveyId}?populate=all`, method: 'GET', headers })).data;
    }

    async getSurveyByCode(surveyCode: string, headers: any): Promise<COTType[]> {
        return (await axios({ url: `${this.baseURL}/api/surveys/fcode/${surveyCode}?populate=all`, method: 'GET', headers })).data;
    }

    async getTaskForChannel(taskGroup: string, channelId: string, headers: any): Promise<COTType[]> {
        return (await axios({ url: `${this.baseURL}/api/tasks/${String(taskGroup)}/bounds/${String(channelId)}`, method: 'GET', headers })).data;
    }

    async getTaskGroupByGroupId(groupId: string, headers: any): Promise<COTType> {
        return (await axios({ url: `${this.baseURL}/api/tasks/group/${String(groupId)}`, method: 'GET', headers })).data;
    }

    async getUserByEmail(email: string, headers: any): Promise<{ data: { users: COTType[] } }> {
        return (await axios({ url: `${this.baseURL}/api/v2/users?${qs.stringify({email})}`, method: 'GET', headers })).data;
    }

    async getUser(id: string, headers: any): Promise<COTType> {
        return (await axios({url: `${this.baseURL}/api/users/${String(id)}`, method: 'GET',  headers})).data;
    }

    // HELPERS
    getOne<T>(obj: T | undefined): T {
        if (!obj) throw new Error('Empty object');
        return obj;
    }

    // Check if array is valid and non-empty
    checkArray(array: COTType[]): boolean {
        if (!array) throw new Error('Empty array (1)');
        if (!Array.isArray(array)) throw new Error('Invalid array');
        if (!array.length) throw new Error('Empty array (2)');
        return true;
    }

    // Extract _id from:
    // [ { _id: 1, code: 'abc' } ]
    getOneFromArray(array: COTType[]): COTType {
        this.checkArray(array);
        if (array.length > 1) throw new Error('Only one element expected in array');
        return this.getOne<COTType>(array[0]);
    }

    // Extract _id from (x) => x.code === 'def'
    // [ { _id: 1, code: 'abc' }, { _id: 1, code: 'def' }, { _id: 1, code: 'hij' } ]
    findOneFromArray(array: COTType[], find: (input: any) => boolean): COTType {
        this.checkArray(array);
        return this.getOne<COTType>(array.find(find));
    }
}
